import { createContext } from 'react';
import { AppTableContextType } from './model';

export const AppTableContext = createContext<AppTableContextType>({} as AppTableContextType);
